import * as React from 'react';
export const IcAlarmOff = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M11 8.76V8a1 1 0 011-1 .93.93 0 01.56.2l2.61-2.61A8.79 8.79 0 0012 4a9 9 0 00-9 9 8.75 8.75 0 00.6 3.16l7.4-7.4zm-7.12-2l2.83-2.88a1.004 1.004 0 00-1.42-1.42L2.46 5.29a1.004 1.004 0 101.42 1.42v.05zM19.46 18a9 9 0 00-.89-11.17L20.49 5a1.055 1.055 0 00-.745-1.798A1.053 1.053 0 0019 3.51L3.51 19A1.053 1.053 0 105 20.49l.91-.92a9 9 0 0012.28 0l1.14 1.15a1.004 1.004 0 101.42-1.42L19.46 18zm-5.34-2.92a1 1 0 01-1.41 0l-1.2-1.19L13 12.44v.15l1.12 1.12a1 1 0 010 1.41v-.04z'
      fill='currentColor'
    />
  </svg>
);
